import { Campaign } from "@mui/icons-material";
import {
  Box,
  CardMedia,
  Fade,
  Slide,
  Stack,
  Typography,
  Zoom,
} from "@mui/material";
import React, { useState, useEffect } from "react";

const VoiceMaker = ({ data }) => {
  const endNumber = 100;
  const duration = 1.5;
  const [count, setCount] = useState(0);
  const [show, setShow] = React.useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 2000);
    const countToNumber = (endNumber, totalDurationInSeconds) => {
      return new Promise((resolve) => {
        const totalSteps = endNumber + 1;
        const delayBetweenSteps = (totalDurationInSeconds * 1000) / totalSteps;

        let currentNumber = 0;
        const interval = setInterval(() => {
          setCount(currentNumber);
          currentNumber += 1;

          if (currentNumber > endNumber) {
            clearInterval(interval);
            resolve();
          }
        }, delayBetweenSteps);
      });
    };

    countToNumber(data.loremLopez, duration);
  }, [data.loremLopez, duration]);

  return (
    <div>
      <Box mt={5}>
        <Box>
          <Fade in timeout={2000}>
            <Typography variant="h5" fontWeight={100}>
              {data.loremLopez?.slice(0, count)}
            </Typography>
          </Fade>
        </Box>

        {show && (
          <Zoom in timeout={1000}>
            <Stack mt={4} alignItems={"center"} spacing={2} direction={"row"}>
              <Campaign
                sx={{
                  height: 40,
                  width: 40,
                }}
              />

              <CardMedia
                sx={{
                  width: {
                    lg: "100%",
                    md: "100%",
                    sm: "90%",
                    xs: "85%",
                  },
                }}
                src="/assets/vc.png"
                component={"img"}
              />
            </Stack>
          </Zoom>
        )}
      </Box>
    </div>
  );
};

export default VoiceMaker;
